(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kpi-cards"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.currentScript.closest('.wl-kpi');
  if (!root) return;

  const animateEl = (el) => {
    const target = parseFloat(el.dataset.value || '0');
    const suffix = el.dataset.suffix || '';
    const duration = parseInt(el.dataset.duration || '1200', 10);
    const start = performance.now();

    const step = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const val = Math.floor(target * p);
      el.textContent = `${val}${suffix}`;
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const nums = root.querySelectorAll('.wl-kpi__number[data-animate="true"]');
  if (!nums.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting && !e.target.dataset.played) {
        e.target.dataset.played = '1';
        animateEl(e.target);
      }
    });
  }, { threshold: 0.4 });

  nums.forEach(n => io.observe(n));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
